var numToShow = 6;
var itemWidth = 90 / numToShow;
var itemHeight = 14.1042;
var dimensionModifier = 6;
var parentWidth = 76;
var startingIndex = 0;
var offset = 0;
var heightOffset = 20;
var margin = 1;
var marginLeft = 0;
var combinedMargin;
var currentIndex;

var mobile = false;
var windowWidth;
var totalProducts;
var idToCheck;
var productType;
var recentlyViewedElements = [];
var recentlyViewedProductsLength;
var recentlyViewedProducts;

const LOCAL_STORAGE_RECENTLYVIEWED_KEY = 'recentlyViewedProducts3';
const LOCAL_STORAGE_TOMORROW_DATE = 'tomorrowDate';
const LOCAL_STORAGE_CHECKEDCURRENTPRODUCTS_KEY = 'checkedCurrentProducts';
const LOCAL_STORAGE_DELIMITER_2 = ',';
var products = [];
//localStorage.setItem(LOCAL_STORAGE_RECENTLYVIEWED_KEY, '');
//localStorage.setItem(LOCAL_STORAGE_TOMORROW_DATE, '');

const getRecentlyViewedProducts = () => {
  const recentlyViewedProducts = localStorage.getItem(LOCAL_STORAGE_RECENTLYVIEWED_KEY) || false;
  if (recentlyViewedProducts) return recentlyViewedProducts.split(LOCAL_STORAGE_DELIMITER_2);
  return [];
};

const setRecentlyViewedProducts = (array) => {
  const recentlyViewedProducts = array.join(LOCAL_STORAGE_DELIMITER_2);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_RECENTLYVIEWED_KEY, recentlyViewedProducts);
  else localStorage.removeItem(LOCAL_STORAGE_RECENTLYVIEWED_KEY);
  return recentlyViewedProducts;
};

const updateRecentlyViewedProducts = (handle) => {
  //console.log(tomorrow)
  //localStorage.setItem(LOCAL_STORAGE_TOMORROW_DATE, tomorrow);
  //localStorage.setItem("tomorrowDate", JSON.stringify(tomorrow));
  
  const recentlyViewedProducts = getRecentlyViewedProducts();
  const indexInRecentlyViewedProducts = recentlyViewedProducts.indexOf(handle);
  if (indexInRecentlyViewedProducts === -1) recentlyViewedProducts.push(handle);
  else recentlyViewedProducts.splice(indexInRecentlyViewedProducts, 1);

  
  return setRecentlyViewedProducts(recentlyViewedProducts);
};

const checkProductExistsTWO = (index, handle) => {
  var indexInRecentlyViewedProducts;
  $.ajax({
    type: "GET",
    async: true,
    url: `/products/${handle}.js`,
    success: function (data) {
      populateRecentlyViewed(index, data);
    },
    error: function (xhr, ajaxOptions, thrownError) {
      console.log(`${xhr.status} ${handle}`);
      //removeFromRecentlyViewedProducts(handle);
      indexInRecentlyViewedProducts = recentlyViewedProducts.indexOf(handle);
      recentlyViewedProducts.splice(indexInRecentlyViewedProducts, 1);
      //console.log('recentlyViewedProducts: ' + recentlyViewedProducts);
      //console.log('indexInRecentlyViewedProducts: ' + indexInRecentlyViewedProducts);
      //console.log(recentlyViewedProducts)
    },
    dataType: "json"
  });
  //return setRecentlyViewedProducts(recentlyViewedProducts);
};

const removeFromRecentlyViewedProducts = (handle) => {
  const recentlyViewedProducts = getRecentlyViewedProducts();
  const indexInRecentlyViewedProducts = recentlyViewedProducts.indexOf(handle);
  //var recentlyViewedProductsProductRemoved = recentlyViewedProducts.slice(indexInRecentlyViewedProducts, 1);
  var recentlyViewedProductsProductRemoved = recentlyViewedProducts.slice(recentlyViewedProducts.indexOf(handle), 1);
  //console.log('recentlyViewedProducts: ' + recentlyViewedProducts);
  //console.log('recentlyViewedProductsProductRemoved: ' + recentlyViewedProductsProductRemoved);
  //console.log('indexInRecentlyViewedProducts: ' + indexInRecentlyViewedProducts);
  //return setRecentlyViewedProducts(recentlyViewedProducts);
};

const recentlyViewedProductsContains = (handle) => {
  const recentlyViewedProducts = getRecentlyViewedProducts();
  return recentlyViewedProducts.includes(handle);
};

function limitProductCount() {
  setRecentlyViewedProducts(recentlyViewedProducts.slice(0, 10).reverse());
}

function getOffset(currentIndex) {
  var itemWidth = $("#recentlyViewedItems").children().first().outerWidth(true);
  if (isNaN(offset)) {
    offset = 0;
  }
  offset = itemWidth * currentIndex * -1;
  return offset;
}


function reorderItems() {
  setTimeout(function() {
    $("#recentlyViewedItems .item").filter(function(){
       return Object.keys(this.dataset).length === 0;
    }).remove();

    $.each(recentlyViewedElements, function(i, item) {
      item.appendTo("#recentlyViewedItems");
    });
    asc=false;   
    var sorted=$('.item').sort(function(a,b){
      return (asc == ($(a).data('index') <  $(b).data('index'))) ? 1 : -1;
    });
    asc = asc ? false : true;
    $('#recentlyViewedItems').html(sorted);
  }, 500)
}

function updateSizes(totalProductsCount) {
  recentlyViewedProductsLength = totalProductsCount;
  windowWidth = $( window ).width();
  //offset = 0;

  if (windowWidth <= 600) {
    mobile = true;
    numToShow = 2;
    margin = 0.65625;
    marginLeft = 0.65625;
    combinedMargin = margin + marginLeft;
    parentWidth = 20;
    //itemWidth = (parentWidth / numToShow - combinedMargin) / ((combinedMargin / numToShow) + 1);
    itemWidth = (parentWidth / numToShow) + marginLeft;
    itemHeight = 3;
  }
  
  else if (windowWidth <= 900) {
    mobile = false;
    numToShow = 3;
    margin = 1.2;
    parentWidth = 42;
    itemWidth = (parentWidth / numToShow - margin);
    itemHeight = 12;
  }
  else if (windowWidth <= 1024) {
    mobile = false;
    numToShow = 3;
    margin = 1.2;
    parentWidth = 48;
    itemWidth = (parentWidth / numToShow - margin);
    itemHeight = 14;
  }
  else if (windowWidth <= 1200) {
    mobile = false;
    numToShow = 4;
    margin = 1.2;
    parentWidth = 58;
    itemWidth = (parentWidth / numToShow - margin);
    itemHeight = 14;
  }
  else if (windowWidth <= 1280) {
    mobile = false;
    numToShow = 4;
    margin = 1.2;
    parentWidth = 64;
    itemWidth = (parentWidth / numToShow - margin);
    itemHeight = 14;
  }
  else if (windowWidth <= 1400) {
    mobile = false;
    numToShow = 5;
    margin = 1.2;
    parentWidth = 70;
    itemWidth = (parentWidth / numToShow - margin);
    itemHeight = 14;
  }
  else {
    numToShow = 6;
    margin = 1.2;
    parentWidth = 76;
    //itemWidth = (parentWidth / numToShow - margin) / ((margin / numToShow) + 1);
    itemWidth = (parentWidth / numToShow - margin);
    itemHeight = 14;
  }

  
  $('#recentlyViewedItems').find('.item').each(function(index){
    $(this).css({'width': `${itemWidth}rem`, 'height': `calc(${itemHeight}rem - ${heightOffset}px`, 'min-height': `calc(${itemHeight}rem - ${heightOffset}px`, 'margin-right': `${margin}rem`, 'margin-left': `${marginLeft}rem`});
    if ($(this).hasClass('active')) {
      currentIndex = $(this).attr('id');
    }
  })

  if (mobile == false) {
    offset = currentIndex * (itemWidth + margin) * -1;
    marginLeft = 0;
    $('#recentlyViewedItems').find('.item').each(function(index){
      $(this).css({'width': `${itemWidth}rem`, 'height': `calc(${itemHeight}rem - ${heightOffset}px`, 'min-height': `calc(${itemHeight}rem - ${heightOffset}px`, 'margin-right': `${margin}rem`, 'margin-left': `${marginLeft}rem`});
    });
  }
  else if (mobile == true) {
    marginLeft = 0.65625;
    combinedMargin = margin + marginLeft;
    offset = currentIndex * (itemWidth + combinedMargin + combinedMargin) * -1;
  }

  if (recentlyViewedProductsLength <= numToShow) {
    $('.fa-circle-chevron-right').addClass('disabled');
  }
  else if (recentlyViewedProductsLength > numToShow) {
    $('.fa-circle-chevron-right').removeClass('disabled');
  }

  $('#recentlyViewedItems').find('.item').each(function(index){
    if ($(this).hasClass('active')) {
      idToCheck = parseInt($(this).attr('id'));
      if (idToCheck >= (recentlyViewedProductsLength - numToShow)){
        $('.fa-circle-chevron-right').addClass('disabled');
      }
    }
  });

  reorderItems();
  return `${itemWidth}rem`;
}

function populateRecentlyViewed(index, product) {
  recentlyViewedProductsLength = getRecentlyViewedProducts().length;
  //console.log(index)
  var productData = product;
  var $recentlyViewedProduct = $("<div/>")
    .addClass("item")
    .attr('id', index)
    .attr('data-index', index)
    .attr('data-product-name', product.handle)
    //.css({'width': updateSizes(recentlyViewedProductsLength), 'height': updateSizes(recentlyViewedProductsLength), 'min-height': updateSizes(recentlyViewedProductsLength), 'margin-right': `${margin}rem`});
    .css({'width': `${itemWidth}rem`, 'height': `calc(${itemHeight}rem - ${heightOffset}px`, 'min-height': `calc(${itemHeight}rem - ${heightOffset}px`, 'margin-right': `${margin}rem`, 'margin-left': `${marginLeft}rem`});
    //.css({'width': '10rem', 'height': '10rem', 'min-height': '10rem', 'margin-right': `${margin}rem`});

  if (index != 0) {
  }
  else {
    $recentlyViewedProduct.addClass('active');
  }
      
  var $recentlyViewedProductCaption = $("<div/>")
    .addClass("product-caption");
  var $recentlyViewedProductButton = $("<a/>")
    .addClass("recentlyViewedProduct")
    .attr('id', productData.handle);
  var $recentlyViewedProductRemove = $("<i/>")
    .addClass("recentlyViewedProduct-Item fal fa-times-circle");
  $($recentlyViewedProductRemove).appendTo($recentlyViewedProductButton);
  $($recentlyViewedProductButton).appendTo($recentlyViewedProductCaption);
  
  var $recentlyViewedProductImageWrap = $("<div/>")
    .addClass("product-image-wrap");
  var $recentlyViewedProductImageLink = $("<a/>")
    .attr("href", productData.url)
    .addClass("image");
  var $recentlyViewedProductImage = $("<img/>")
    .attr("src", productData.images[0]);
  $($recentlyViewedProductImageLink).appendTo($recentlyViewedProductImageWrap);
  $($recentlyViewedProductImage).appendTo($recentlyViewedProductImageLink);
  $($recentlyViewedProductImageWrap).appendTo($recentlyViewedProductCaption);

  var $recentlyViewedProductTitle = $("<div/>")
    .addClass("productTitle");
  var $recentlyViewedProductTitleForMobile = $("<a/>")
    .addClass("titleforMobile")
    .attr("href", productData.url);

  var productHeading = '';
  var productSubheading = '';

  $.each(productData.tags, function( index, value ) {
    if (value.indexOf("type_") >= 0) {
      productType = value.replace('type_', '')
    }
    else if (value.indexOf("type_") == 0) {
      productType = '';
    }
  });
  
  if (productData.title.indexOf("The Firm One") >= 0 ||
    productData.title.indexOf("The Memory One") >= 0 ||
    productData.title.indexOf("The Natural One") >= 0 ||
    productData.title.indexOf("Fabb Package Deal") >= 0) {
    productHeading = productData.title.split(" ");
    productSubheading = productHeading.slice(3,productHeading.length).join(" ");
    //$recentlyViewedProductTitleForMobile.html(`<span class="productHeading">${productHeading[0]} ${productHeading[1]} ${productHeading[2]}</span> <span class="productSubheading">${productSubheading}</span>`);
    //$recentlyViewedProductTitleForMobile.html(`<span class="productHeading">${productHeading[0]} ${productHeading[1]} ${productHeading[2]}</span>`);
    if (productType != typeof('undefined')) {
      $recentlyViewedProductTitleForMobile.html(`<span class="productHeading">${productHeading[0]} ${productHeading[1]} ${productHeading[2]}</span> <span class="productSubheading">${productType}</span>`);
    }
  }
  else if (productData.title.indexOf("Ballad Premium") >= 0) {
    productHeading = productData.title.split(" ");
    productSubheading = productHeading.slice(2,productHeading.length).join(" ");
    //$recentlyViewedProductTitleForMobile.html(`<span class="productHeading">${productHeading[0]} ${productHeading[1]}</span> <span class="productSubheading">${productSubheading}</span>`);
    //$recentlyViewedProductTitleForMobile.html(`<span class="productHeading">${productHeading[0]} ${productHeading[1]}</span>`);
    if (productType != typeof('undefined')) {
      $recentlyViewedProductTitleForMobile.html(`<span class="productHeading">${productHeading[0]} ${productHeading[1]}</span> <span class="productSubheading">${productType}</span>`);
    }
  }
  else {
    productHeading = productData.title.split(" ");
    productSubheading = productHeading.slice(1,productHeading.length).join(" ");
    //$recentlyViewedProductTitleForMobile.html(`<span class="productHeading">${productHeading[0]}</span> <span class="productSubheading">${productSubheading}</span>`);
    //$recentlyViewedProductTitleForMobile.html(`<span class="productHeading">${productHeading[0]}</span>`);
    if (productType != typeof('undefined')) {
      $recentlyViewedProductTitleForMobile.html(`<span class="productHeading">${productHeading[0]}</span> <span class="productSubheading">${productType}</span>`);
    }
  }

  $($recentlyViewedProductTitleForMobile).appendTo($recentlyViewedProductTitle);
  $($recentlyViewedProductTitle).appendTo($recentlyViewedProductCaption);
  $($recentlyViewedProductCaption).appendTo($recentlyViewedProduct);
  
  updateSizes(recentlyViewedProductsLength);
  recentlyViewedElements.push($recentlyViewedProduct);
  
  productType = '';
}

function updateIDs() {
  recentlyViewedProductsLength = $('#recentlyViewedItems').find('.item').length;
  //console.log(recentlyViewedProductsLength)
  $('#recentlyViewedItems').find('.item').each(function(index){
    $(this).attr('id', index).data('index', index);
  })
}

function hideContainer(totalProductsArg) {
  var recentlyViewedProductsLength = totalProductsArg;
  if (recentlyViewedProductsLength != 0) {
    $('#recentlyViewedContainer').show();
  }
  else {
    $('#recentlyViewedItemsContainer').closest('.wrapper').html('').css('height', '10px');
  }
}

$(document).ready(function() {

  /*
    for (var i = 0; i < localStorage.length; i++) {
      console.log(localStorage.key(i) + "=[" + localStorage.getItem(localStorage.key(i)) + "]");
    }
  */
  
  var ids = [];
  recentlyViewedProducts = getRecentlyViewedProducts().reverse();

  recentlyViewedProductsLength = getRecentlyViewedProducts().length;

  var totalProducts = products.length;
  totalProducts = recentlyViewedProductsLength;
  
  updateSizes(totalProducts);
  
  $(document).on('click', '.recentlyViewedProduct', function () {
    $(this).closest('.item').remove();
    //updateRecentlyViewedProducts($(this).data('product-name'));
    updateRecentlyViewedProducts(this.id);
    recentlyViewedProductsLength = getRecentlyViewedProducts().length;
    if (recentlyViewedProductsLength <= numToShow) {
      $('.fa-circle-chevron-right').addClass('disabled');
    }

    $('#recentlyViewedItems').find('.item').each(function(index){
      if ($(this).hasClass('active')) {
        idToCheck = parseInt($(this).attr('id'));
        if (idToCheck >= (recentlyViewedProductsLength - numToShow)){
          $('.fa-circle-chevron-right').addClass('disabled');
        }
      }
    });
    hideContainer(recentlyViewedProductsLength);
  });

    //var startTime = performance.now()
      $.each(recentlyViewedProducts, function(index, value) {
        checkProductExistsTWO(index, value);
      })
    //var endTime = performance.now()
    //console.log(`Took ${endTime - startTime} milliseconds`);
  
    updateSizes(recentlyViewedProductsLength);

      var $recentlyViewedItemsContainer = $("<div/>")
        .attr('id', 'recentlyViewedItemsContainer');
      var $recentlyViewedItemsWrapper = $("<div/>")
        .attr('id', 'recentlyViewedItemsWrapper');
      $('#recentlyViewedItems').wrap($recentlyViewedItemsWrapper);
      $('#recentlyViewedItemsWrapper').wrap($recentlyViewedItemsContainer);
  
      if (recentlyViewedProductsLength > 0) {
        var $recentlyViewedItemsChevron = $("<i/>")
          .addClass('fa-solid')
          .addClass('fa-chevron-up')
          .appendTo('#recentlyViewedContainer');
      }
  
      var $leftButton = $("<i/>")
        .addClass("fa-solid fa-circle-chevron-left disabled")
        .prependTo('#recentlyViewedItemsContainer');
      var $rightButton = $("<i/>")
        .addClass("fa-solid fa-circle-chevron-right")
        .appendTo('#recentlyViewedItemsContainer');
      recentlyViewedProductsLength <=  numToShow ? $rightButton.addClass('disabled') : $rightButton.removeClass('disabled');

    $(".fa-circle-chevron-left").click(function() {
      updateIDs();
      var chevronLeft = $(this);
      if (recentlyViewedProductsLength >  numToShow) {
        $(".fa-circle-chevron-right").removeClass('disabled');
      }
      if (!chevronLeft.hasClass('disabled')) {
        startingIndex --;
        $('#recentlyViewedItems').find('.item').each(function(index){
          $(this).attr('id') == startingIndex -1 ? $(this).addClass('previous') : $(this).removeClass('previous');
          $(this).attr('id') == startingIndex ? ($(this).addClass('active'), currentIndex = $(this).attr('id')) : $(this).removeClass('active');
          $(this).attr('id') == startingIndex +1 ? $(this).addClass('next') : $(this).removeClass('next');
          //$(this).attr('id') == '0' && $(this).hasClass('active') ? chevronLeft.addClass('disabled') : chevronLeft.removeClass('disabled');
          if ($(this).attr('id') != '0') {
          }
          else {
            $(this).hasClass('active') ? chevronLeft.addClass('disabled') : chevronLeft.removeClass('disabled');
          }
        })
        $('#recentlyViewedItems').css({"transform": `translate3d(${getOffset(currentIndex)}px, 0px, 0px)`, 'transition-duration': '300ms'});
      }

      $('#recentlyViewedItems').find('.item').each(function(index){
        if ($(this).hasClass('active')) {
          idToCheck = parseInt($(this).attr('id'));
          if (currentIndex >= (recentlyViewedProductsLength - numToShow)){
            $('.fa-circle-chevron-right').addClass('disabled');
          }
        }
      });
    });

    $(".fa-circle-chevron-right").click(function() {
      updateIDs();
      var chevronRight = $(this);
      if (recentlyViewedProductsLength >  numToShow) {
        $(".fa-circle-chevron-left").removeClass('disabled');
      }
      if (!chevronRight.hasClass('disabled')) {
        startingIndex ++;
        $('#recentlyViewedItems').find('.item').each(function(index){
          $(this).attr('id') == startingIndex -1 ? $(this).addClass('previous') : $(this).removeClass('previous');
          $(this).attr('id') == startingIndex ? ($(this).addClass('active'), currentIndex = $(this).attr('id')) : $(this).removeClass('active');
          $(this).attr('id') == startingIndex +1 ? $(this).addClass('next') : $(this).removeClass('next');
          if ($(this).attr('id') != recentlyViewedProductsLength - numToShow) {
          }
          else {
            $(this).hasClass('active') ? chevronRight.addClass('disabled') : chevronRight.removeClass('disabled');
          }
        })
        $('#recentlyViewedItems').css({"transform": `translate3d(${getOffset(currentIndex)}px, 0px, 0px)`, 'transition-duration': '300ms'});
      }
      $('#recentlyViewedItems').find('.item').each(function(index){
        if ($(this).hasClass('active')) {
          idToCheck = parseInt($(this).attr('id'));
          if (currentIndex >= (recentlyViewedProductsLength - numToShow)){
            $('.fa-circle-chevron-right').addClass('disabled');
          }
        }
      });
    });
    
    $('#recentlyViewedContainer').find('i').click(function() {
      var upClass = 'fa-chevron-up';
      var downClass = 'fa-chevron-down';
      $(this).hasClass(upClass) ? $(this).toggleClass(upClass).toggleClass(downClass) : $(this).toggleClass(downClass).toggleClass(upClass);
      $('#recentlyViewedItemsContainer').slideToggle();
    });
  
    reorderItems();
    updateSizes(recentlyViewedProductsLength);
    hideContainer(recentlyViewedProductsLength);
    limitProductCount();

    $(".item").on("swipe",function(){
      console.log('swiped')
    });
  
  });

$( window ).resize(function() {
  updateSizes(recentlyViewedProductsLength);
});